import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { HttpService } from '../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { FADE_IN } from '../../util/animations/animation';
import { DownloadService } from '../services/download.service';
import { CommunicationService } from '../../services/communication/communication.service';
import { HelperService } from '../../util/helper/helper.service';
/**
 * This component is used to show the surveys which have been taken by the user. This show the accordion view for each survey and child accordion for responses
 * 
 * List of different survey responses for the particular patient, If patient gives multiple responses for same survey then it shows multiple items under the survey name. The survey repose contents question and answers, the answers might be text, multiple options or a attachments. If it has attachments then we show download button so that CareAlly can able to 
 */
@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  animations: [FADE_IN]
})
export class SurveyComponent implements OnInit {
  @Input() patientId: any = '';
  @Input() patientDetails = {};
  @Output() public count = new EventEmitter();
  allSurveys = [];
  showLoader = false;
  communicationServiceListner;

  constructor(private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private helper: HelperService,
    private communicationService: CommunicationService,
    private downloadService: DownloadService) {
      this.communicationServiceListner = this.communicationService.getTemplateData.subscribe(data=>{
        if(data.surveys)
          this.allSurveys = data.surveys;
      })
    }

  ngOnInit() {
    if (this.patientId) {
      this.getAllSurveys();
    }
  }

  /**
   * This function is used to get all the surveys and get the latest response from the latest survey
   */
  async getAllSurveys() {
    this.loader.show('progress');
    this.httpService.get(`questionnaire/survey?patientId=${this.patientId}`)
      .subscribe((response: any) => {
        this.allSurveys = response;
        let count = 0;
        this.allSurveys.map((item:any) =>{
          item.isExpand = false;
          item.responses.map(x=> {
            count++;
            x.questionnaire = [];
          })
        })
        if(this.allSurveys.length){ // Get first response from assesment
          this.getSurveyById(this.allSurveys[0].responses[0]).then(res=>{
            this.communicationService.setTemplateData(this.allSurveys, 'surveys');
            let assessment = [...this.allSurveys];
            assessment = assessment.filter(x => {
              return x.responses.findIndex(y => y.selected) !==-1;
            })
            this.communicationService.setTemplateData(assessment, 'assessment'); 
          })
          .catch(()=>{
            this.communicationService.setTemplateData([], 'assessment');
          })
        }else{
          this.communicationService.setTemplateData([], 'assessment');
        }
        this.count.emit(count);
        this.loader.hide('progress');
      }, error => {
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  /**
   * This function gets called when user expand the response
   * @param response 
   */
  onResponseExpand(response){
    if(!response.questionnaire.length)
      this.getSurveyById(response);
  }

  /**
   * This function gets called when user expand the survey
   * @param survey 
   */
  onSurveyExpand(survey){
    survey.isExpand = true;
    if(!survey.responses[0].questionnaire.length)
      this.getSurveyById(survey.responses[0]);
    else
      survey.responses[0].isExpand = true;
  }

  /**
   * This function gets called when user collapse the survey
   * @param survey 
   */
  onSurveyPanelClosed(survey){
    survey.responses.map(x=> {x.isExpand = false});
    survey.isExpand = false; 
  }

  /**
   * This function gets called when user collapse the response
   * @param survey 
   */
  onResponsePanelClosed(response){
    response.isExpand = false;
  }

  /**
   * This will get reponse details based on survey Id. After getting the response it filters the data 
   * @param response 
   */
  getSurveyById(response) {
    return new Promise((resolve, reject)=>{
    this.showLoader = true;
    this.httpService.get(`questionnaire/response/${response.id}`)
      .subscribe((res: any) => {
        this.showLoader = false;
        response.questionnaire = res.survey.filter(x=> {
          if(x.answer&&x.answer.length && x.type==='boolean')
            x.answer = [this.getAnswer(x.answer[0])]
          if(x.type==='reference' && x.intent=== 'signature' && x.answer && x.answer.length)
            this.getMedia(x)

          return x.type !== 'display';
        });
        if(res.hiddenFields){
          response.hiddenFields = Object.entries(res.hiddenFields);
        }
        response.isExpand = true;
        resolve(true);
      }, error => {
        this.showLoader = false;
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
        reject(error);
      })
    })
  }

  /**
   * This function is used to get the media file to show those on UI. for e.g. Signature
   * @param data 
   */
  getMedia(data){
    const id = this.helper.extractId(data.answer[0]);
    this.loader.show('progress');
    this.httpService.get(`media/${id}`)
      .subscribe((response: any) => {
        this.loader.hide('progress');
        data.src = `data:${response.content.contentType};base64,${response.content.data}`;
      }, () =>{
        this.loader.hide('progress');
      })
  }

  transform(base64Image){
    return this.helper.transform(base64Image);
  }

  /**
   * This function is used to convet the boolean value to the strings
   * @param answer 
   */
  getAnswer(answer){
    if(answer === 'true' || answer === true)
      return 'Yes'
    else if(answer === 'false' || answer === false) 
      return 'No'
    else 
      return answer
  }

  /**
   * This function is used to download the image from the response
   * @param data 
   */
  downloadDocs(data){
    if(data&&data.reference){
    const mediaId = data.reference.split('Media/').pop();
    this.loader.show('progress');
    this.httpService.get(`media/${mediaId}`)
      .subscribe((response: any) => {
        this.loader.hide('progress');
        this.downloadService.downloadFile(response.content, this.patientDetails)
      }, error =>{
        this.loader.hide('progress');
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
      })
    }else{
      this.toastr.warning('There was a problem saving the document.', 'Document', {
        progressBar: true, timeOut: 3000
      });
    }
  }

  ngOnDestroy(): void {
    this.communicationServiceListner.unsubscribe();
  }

}
